import { type PropsWithChildren, forwardRef, ReactNode } from "react";
import { cn } from "../utils/cn";
import { BulletSectionTitle } from "./BulletSectionTitle";

type Props = PropsWithChildren<{
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  className?: string;
  wrapperClassName?: string;
  containerComponent?: React.ElementType;
}>;

export const SectionCard = forwardRef<HTMLDivElement, Props>(
  (
    {
      title,
      subtitle,
      icon,
      children,
      className,
      wrapperClassName,
      containerComponent,
    },
    ref,
  ) => {
    const ContainerComponent: React.ElementType = containerComponent ?? "div";

    return (
      <div className={cn("gap-2", wrapperClassName)}>
        <ContainerComponent
          ref={ref}
          className={cn(
            "p-6 rounded-3xl bg-white border border-gray-2 flex flex-col gap-4",
            className,
          )}
        >
          <div className="flex justify-between items-center mb-2">
            <div>
              <h3 className="text-base font-extrabold text-black">{title}</h3>
              {subtitle && (
                <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
              )}
            </div>
            {icon && <div>{icon}</div>}
          </div>
          {children}
        </ContainerComponent>
      </div>
    );
  },
);

SectionCard.displayName = "SectionCard";
